'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dPassword$0024$0024anon$002482 from "./presto.types$-Password$$anon$82.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Password$() {
  this.c83 = null;
  this.c84 = false;
  this.c85 = null;
  this.c86 = false;
}
export { $c_Lpresto_types$Password$ as $c_Lpresto_types$Password$ };
$p = $c_Lpresto_types$Password$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Password$;
/** @constructor */
function $h_Lpresto_types$Password$() {
}
export { $h_Lpresto_types$Password$ as $h_Lpresto_types$Password$ };
$h_Lpresto_types$Password$.prototype = $p;
$p.cs5 = (function() {
  if ((!this.c84)) {
    this.c83 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD;
    this.c84 = true;
  }
  return this.c83;
});
$p.a2M = (function() {
  if ((!this.c86)) {
    this.c85 = new $j_presto$002etypes$0024$002dPassword$0024$0024anon$002482.$c_Lpresto_types$Password$$anon$82(this);
    this.c86 = true;
  }
  return this.c85;
});
$p.T1 = (function(it) {
  return (($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__trim__T(it) === "") || ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__trim__T(it).length < 6));
});
var $d_Lpresto_types$Password$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Password$, "presto.types$Password$", ({
  a0E: 1,
  D: 1
}));
export { $d_Lpresto_types$Password$ as $d_Lpresto_types$Password$ };
var $n_Lpresto_types$Password$;
function $m_Lpresto_types$Password$() {
  if ((!$n_Lpresto_types$Password$)) {
    $n_Lpresto_types$Password$ = new $c_Lpresto_types$Password$();
  }
  return $n_Lpresto_types$Password$;
}
export { $m_Lpresto_types$Password$ as $m_Lpresto_types$Password$ };
//# sourceMappingURL=presto.types$-Password$.js.map
